import React from 'react';

import { ImageWidgetProperties } from '@ael/core-api';
import { SmartImage } from '@ael/shared-components-library';

import './StudentImage.scss';

interface StudentImageProps {
  url: string;
  imageWidth: number;
  imageHeight: number;
  properties: ImageWidgetProperties;
}

export const StudentImage: React.FC<StudentImageProps> = ({ url, properties, imageWidth, imageHeight }) => {
  return (
    <SmartImage
      src={url}
      alt={properties.caption}
      className="student-image"
      maxImageHeight="large"
      loaderWidth={imageWidth}
      loaderHeight={imageHeight}
      loaderStyle={{
        maxWidth: `${properties.width}%`,
        borderRadius: `${properties.roundCorners}px`,
      }}
      enableZoom={true}
      style={{
        maxWidth: `${properties.width}%`,
        borderRadius: `${properties.roundCorners}px`,
      }}
    />
  );
};
